import { facilityInfrastructureEnumsCurrentStatusOptionEnum } from '@/gen/types/FacilityInfrastructureEnumsCurrentStatusOption';
import { facilityInfrastructureEnumsFaultTypeOptionEnum } from '@/gen/types/FacilityInfrastructureEnumsFaultTypeOption';
import { facilityInfrastructureEnumsPotentialConsequenceOptionEnum } from '@/gen/types/FacilityInfrastructureEnumsPotentialConsequenceOption';
import { yesNoOptionEnum } from '@/gen/types/YesNoOption';

import { whenPathEquals, whenPathIncludes } from './conditions';
import type { IncidentFieldRule } from './types';

export const facilityInfrastructureFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'Type of facility infrastructure issue',
        description: 'Select the affected facility system or fault type.',
        order: 90,
    },
    {
        key: 'powerAssetID',
        label: 'Asset ID',
        description: 'Enter the asset ID (e.g., UPS-02, GEN-01).',
        order: 100,
    },
    {
        key: 'powerLocation',
        label: 'Where is the affected asset located?',
        description: 'Enter the data hall number, rack, or zone. Be as specific as possible.',
        order: 110,
    },
    {
        key: 'potentialConsequence',
        label: 'Potential operational consequences',
        description: 'Select all potential consequences, e.g. downtime, capacity loss.',
        order: 120,
    },
    {
        key: 'potentialConsequenceExplanation',
        label: 'Potential consequence explanation',
        kind: 'textarea',
        order: 130,
        visibleWhen: whenPathIncludes('potentialConsequence', facilityInfrastructureEnumsPotentialConsequenceOptionEnum.Other),
        requiredWhen: whenPathIncludes(
            'potentialConsequence',
            facilityInfrastructureEnumsPotentialConsequenceOptionEnum.Other,
        ),
    },
    {
        key: 'currentStatus',
        label: 'Current status of the asset',
        description: 'Select the current operational state of the affected asset.',
        order: 140,
    },
    {
        key: 'currentStatusExplanation',
        label: 'Current status explanation',
        kind: 'textarea',
        order: 150,
        visibleWhen: whenPathIncludes('currentStatus', facilityInfrastructureEnumsCurrentStatusOptionEnum.Other),
        requiredWhen: whenPathIncludes('currentStatus', facilityInfrastructureEnumsCurrentStatusOptionEnum.Other),
    },
    {
        key: 'redundancyLevelAffected',
        label: 'Affected redundancy level',
        description: 'Select the redundancy level impacted, e.g. N, N+1, 2N.',
        order: 160,
    },
    {
        key: 'affectedRedundancyLevelExplanation',
        label: 'Affected redundancy level explanation',
        kind: 'textarea',
        order: 170,
        visibleWhen: whenPathEquals('redundancyLevelAffected', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('redundancyLevelAffected', yesNoOptionEnum.Yes),
    },
    {
        key: 'redundancyLevelDefinition',
        label: 'Redundancy level definition',
        kind: 'textarea',
        order: 180,
        visibleWhen: whenPathEquals('redundancyLevelAffected', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('redundancyLevelAffected', yesNoOptionEnum.Yes),
    },
    {
        key: 'faultType',
        label: 'What type of fault occurred?',
        description: 'Select the type of fault, e.g. mechanical, electrical, software.',
        order: 190,
    },
    {
        key: 'faultTypeExplanation',
        label: 'Fault type explanation',
        kind: 'textarea',
        order: 200,
        visibleWhen: whenPathIncludes('faultType', facilityInfrastructureEnumsFaultTypeOptionEnum.Other),
        requiredWhen: whenPathIncludes('faultType', facilityInfrastructureEnumsFaultTypeOptionEnum.Other),
    },
    {
        key: 'alarmCodeSource',
        label: 'Source of the alarm or alert',
        description: 'Enter the system or tool that generated the alarm, e.g. BMS, DCIM.',
        order: 210,
    },
    {
        key: 'unplannedEmission',
        label: 'Did this cause unplanned CO2 emissions?',
        description: 'Select Yes if the incident caused unexpected CO2 emissions.',
        order: 220,
    },
];
